var  nav = document.getElementById('menu-fd');

window.onscroll = function(){

   if (window.pageYOffset >100) {

		nav.style.background = "#000";
	}
	else{
		nav.style.background = "transparent";
	}
}